import React from 'react';
import { InputBase, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  input: {
    width: '100%',
    padding: 20,
    margin: '6px 0px 20px',
    borderRadius: 8,
    border: '1px solid #A6A6A6',
    backgroundColor: '#fff',
    ...theme.typography.pRegular,
  },
}));

export const CourseCommentInput = ({
  title,
  rows,
  placeHolder,
  onChange,
  value,
  name,
}) => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h6" color="primary">
        {title}
      </Typography>
      <InputBase
        type="text"
        className={classes.input}
        multiline
        rows={rows || 3}
        placeholder={placeHolder}
        value={value}
        name={name}
        onChange={onChange}
        inputProps={{ 'aria-label': 'Answer' }}
      />
    </>
  );
};
